import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="男同网社群平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-heading">
            {heroData.title}
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-10 max-w-2xl mx-auto">
            {heroData.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={heroData.secondaryCtaLink}
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaText}
            </Link>
            <a
              href={heroData.secondaryCtaLink}
              className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroData.secondaryCtaText}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#features" className="text-white/60 hover:text-white transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}